(function () {
  const initTestimonialCarousel = () => {
    document
      .querySelectorAll('.section-testimonial-carousel')
      .forEach((section) => {
        const sectionId = section.id;
        if (!sectionId) return;

        const swiperEl = section.querySelector('.tc-swiper');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        const navNext = section.querySelector('.swiper-button-next');
        const navPrev = section.querySelector('.swiper-button-prev');
        let navConfig = {};

        if (navNext && navPrev) {
          navConfig = {
            navigation: {
              nextEl: `#${sectionId} .swiper-button-next`,
              prevEl: `#${sectionId} .swiper-button-prev`,
            },
          };
        }

        new Swiper(swiperEl, {
          slidesPerView: 1.1,
          spaceBetween: 16,
          grabCursor: true,
          watchSlidesProgress: true,
          ...navConfig,
          breakpoints: {
            768: {
              slidesPerView: 2.3,
              spaceBetween: 20,
            },
          },
        });
      });
  };

  const loadSwiperAndInit = () => {
    if (typeof Swiper !== 'undefined') {
      initTestimonialCarousel();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = initTestimonialCarousel;
    document.head.appendChild(script);
  };

  document.addEventListener('DOMContentLoaded', function () {
    loadSwiperAndInit();

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('section-testimonial-carousel')) {
        loadSwiperAndInit();
      }
    });
  });
})();
